import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import {
  DocumentoTipoRequisito,
  eEstadoDocumento,
  EstadoSolicitud,
  OtroDocumentoSecciones,
  ParametrosMaestro,
  SolicitudSeccion,
} from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { FilterConfiguracionDocumentoModel } from 'src/app/models/configuracion-documento/FilterConfiguracionDocumentoModel';

import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { DocumentacionRequeridaModel } from 'src/app/models/solicitud/DocumentacionRequeridaModel';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfiguracionDocumentoService } from 'src/app/services/configuracion-documento/configuracion-documento.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';

// import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
// import { IFilterTipoVisitaModel } from 'src/app/models/interfaces/tipo-visita/IFilterTipoVisitaModel';
// import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
// import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
// import { SedeModel } from 'src/app/models/sede/SedeModel';
// import { ContratistaModel } from 'src/app/models/contratista/ContratistaModel';
// import { FilterContratistaModel } from 'src/app/models/contratista/FilterContratistaModel';
// import { FilterTipoVisitaModel } from 'src/app/models/tipo-visita/FilterTipoVisitaModel';
// import { TipoVisitaModel } from 'src/app/models/tipo-visita/TipoVisitaModel';
// import { ContratistaService } from 'src/app/services/contratista/contratista.service';
// import { SedeService } from 'src/app/services/sede/sede.service';
// import { TipoVisitaService } from 'src/app/services/tipo-visita/tipo-visita.service';

import {
  AdjuntarTipoDocumentoDialogComponent,
  AdjuntarTipoDocumentoModel,
} from '../../tipo-documento/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog/adjuntar-tipo-documento-dialog.component';

@Component({
  selector: 'app-solicitud-editar',
  templateUrl: './solicitud-editar.component.html',
  styleUrls: ['./solicitud-editar.component.css'],
})
export class SolicitudEditarComponent implements OnInit {
  displayedColumns: string[] = ['nombre', 'requisito', 'restringeAcceso', 'acciones'];
  // listaSearchDocumentacionPersonalRequerido: DocumentacionRequeridaModel[];
  // listaSearchDocumentacionVehiculosRequeridos: DocumentacionRequeridaModel[];
  // listaSearchDocumentacionEquiposRequeridos: DocumentacionRequeridaModel[];
  // listaSearchDocumentacionTecnicaRequerida: DocumentacionRequeridaModel[];

  id: number;
  model: ISolicitudModel = new SolicitudModel();
  listaTipoRequisitos: ParametroModel[] = new Array<ParametroModel>();
  textoTodos: string = '';
  // listaSedes: SedeModel[] = new Array<SedeModel>();
  // listaTipoVisita: TipoVisitaModel[] = new Array<TipoVisitaModel>();
  // listaContratistas: ContratistaModel[] = new Array<ContratistaModel>();

  seccionPersonal: SolicitudSeccion = SolicitudSeccion.Personal;
  seccionEquipos: SolicitudSeccion = SolicitudSeccion.Equipos;
  seccionVehiculos: SolicitudSeccion = SolicitudSeccion.Vehiculos;
  seccionDocumentacionTecnica: SolicitudSeccion =
    SolicitudSeccion.DocumentacionTecnica;

  @ViewChild('tablePersonal', { static: true, read: MatTable })
  tablePersonal!: MatTable<any>;
  @ViewChild('tableEquipos', { static: true, read: MatTable })
  tableEquipos!: MatTable<any>;
  @ViewChild('tableVehiculos', { static: true, read: MatTable })
  tableVehiculos!: MatTable<any>;
  @ViewChild('tableDocumentacionTecnica', { static: true, read: MatTable })
  tableDocumentacionTecnica!: MatTable<any>;

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private dialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private configuracionDocumentoService: ConfiguracionDocumentoService,
    private solicitudService: SolicitudService,
    private serviceParametros: ParametroService,
    // private sedeService: SedeService,
    // private contratistaService: ContratistaService,
    // private tipoVisitaService: TipoVisitaService,
    // private configuracionDocumentoService: ConfiguracionDocumentoService,
    private router: Router
  ) {
    this.id = 0;
    // this.listaSearchDocumentacionPersonalRequerido =
    //   new Array<DocumentacionRequeridaModel>();
    // this.listaSearchDocumentacionVehiculosRequeridos =
    //   new Array<DocumentacionRequeridaModel>();
    // this.listaSearchDocumentacionEquiposRequeridos =
    //   new Array<DocumentacionRequeridaModel>();
    // this.listaSearchDocumentacionTecnicaRequerida =
    //   new Array<DocumentacionRequeridaModel>();

    this.route.params.subscribe((params) => {
      this.id = params['id']; // (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
    });

    this.solicitudService.getById(this.id).subscribe((data: SolicitudModel) => {
      this.model = data;
      this.model.idSedeSelected = this.model.idSede;
      this.model.idCompaniaSelected = this.model.idCompania;
      this.model.idTipoVisitaSelected = this.model.idTipoVisita;

      this.model.lista_documentos_personal =
        this.model.documentosRequeridos.filter(
          (p) => p.seccion == SolicitudSeccion.Personal
        );
      this.model.lista_documentos_equipos =
        this.model.documentosRequeridos.filter(
          (p) => p.seccion == SolicitudSeccion.Equipos
        );
      this.model.lista_documentos_vehiculos =
        this.model.documentosRequeridos.filter(
          (p) => p.seccion == SolicitudSeccion.Vehiculos
        );
      // this.model.lista_documentos_tecnicos =
      //   this.model.documentosRequeridos.filter(
      //     (p) => p.seccion == SolicitudSeccion.DocumentacionTecnica
      //   );
    });
  }

  ngOnInit(): void {
    

    this.serviceParametros.getDetalles(ParametrosMaestro.TIPO_REQUISITO).subscribe((data) => {
      this.listaTipoRequisitos = data.items;
      let paramTodos = this.listaTipoRequisitos.find(p => p.idParametroDetalle == DocumentoTipoRequisito.TODOS);
      if(paramTodos)
        this.textoTodos = paramTodos.valor;
    });

    

    // const filterConfiguracionDocumentos: IFilterConfiguracionDocumentoModel =
    //   new FilterConfiguracionDocumentoModel();
    // // filterConfiguracionDocumentos.pageSize = 100;
    // this.configuracionDocumentoService
    //   .getList(filterConfiguracionDocumentos)
    //   .subscribe(
    //     (dataDocumentos: DocumentacionRequeridaModel[]) => {
    //       dataDocumentos.forEach((p) => {
    //         p.esRequisitoBloqueado =
    //           p.idRequisito === DocumentoTipoRequisito.TODOS;
    //       });

    //       // this.model.listaDocumentos = dataDocumentos.items;
    //       // this.listaSearchDocumentacionPersonalRequerido =
    //       //   dataDocumentos.filter(
    //       //     (p) => p.seccion == SolicitudSeccion.Personal
    //       //   );

    //       // this.listaSearchDocumentacionEquiposRequeridos =
    //       //   dataDocumentos.filter(
    //       //     (p) => p.seccion == SolicitudSeccion.Equipos
    //       //   );

    //       // this.listaSearchDocumentacionVehiculosRequeridos =
    //       //   dataDocumentos.filter(
    //       //     (p) => p.seccion == SolicitudSeccion.Vehiculos
    //       //   );

    //       // this.listaSearchDocumentacionTecnicaRequerida =
    //       //   dataDocumentos.filter(
    //       //     (p) => p.seccion == SolicitudSeccion.DocumentacionTecnica
    //       //   );
    //     }
    //   );
  }

  getConfiguracionDocumentosPorTipoVisita(selectedValue: number) {
    const filterConfiguracionDocumentos: IFilterConfiguracionDocumentoModel =
      new FilterConfiguracionDocumentoModel();
    
    if(this.model.idTipoVisitaSelected)
      filterConfiguracionDocumentos.idTipoVisita = this.model.idTipoVisitaSelected;
      
    this.configuracionDocumentoService
      .getList(filterConfiguracionDocumentos)
      .subscribe((data: DocumentacionRequeridaModel[]) => {
        // console.log(data);
        data.forEach((p) => {
          p.esRequisitoBloqueado =
            p.idRequisito === DocumentoTipoRequisito.TODOS;
        });

        this.model.lista_documentos_personal = data.filter(
          (p) => p.seccion == SolicitudSeccion.Personal && p.esPredeterminado
        );
        this.model.lista_documentos_equipos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Equipos && p.esPredeterminado
        );
        this.model.lista_documentos_vehiculos = data.filter(
          (p) => p.seccion == SolicitudSeccion.Vehiculos && p.esPredeterminado
        );

        this.model.documentosTecnicos = data
          .filter(
            (p) =>
              p.seccion == SolicitudSeccion.DocumentacionTecnica &&
              p.esPredeterminado
          )
          .map((item) => {
            let documento = new SolicitudDocumentoTecnicoModel();
            documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
            documento.idMaestroDocumento = item.idMaestroDocumento;
            documento.documento = item.documento;
            documento.esPredeterminado = item.esPredeterminado;
            documento.idRequisito = item.idRequisito;
            // documento2.seccion = idSeccion;
            documento.controlarFechas = item.controlarFechas;
            documento.esRequisitoBloqueado =
              documento.idRequisito === DocumentoTipoRequisito.TODOS;

            return documento;
          });
      });
  }

  save() {
    this.model.idEstado = EstadoSolicitud.EN_ELABORACION;
  }

  submit() {
    this.model.idEstado = EstadoSolicitud.SOLICITADO;
  }
  
  closed(){
    this.dialogService.open('Se perderán los cambios no guardados ¿esta seguro de salir?'); //options
          this.dialogService.confirmed().subscribe((confirmed) => {
            if (confirmed) {
              this.router.navigate(['/solicitudes-engie']);
            }
          });
  }

  onSubmit(form: NgForm) {
    if (form.invalid) {
      if (form.controls.notificarA.status == 'INVALID') {
        this.alertDialogService.open('Error en campo Notificar A (correo).');
      } else {
        this.alertDialogService.open('Debe ingresar en campos requeridos');
      }
    } else {
      if (this.model.idSedeSelected)
        this.model.idSede = this.model.idSedeSelected;

      if (this.model.idTipoVisitaSelected)
        this.model.idTipoVisita = this.model.idTipoVisitaSelected;

      if (this.validar()) {
        this.dialogService.open('¿Deseas guardar los cambios?'); //options

        this.dialogService.confirmed().subscribe((confirmed) => {
          if (confirmed) {
            // this.saveData();
            this.submitForm();
          }
        });
      }
    }
  }

  validar(): boolean {
    let errors = 0;

    if (this.model.idContratista === 0) {
      this.alertDialogService.open('Debe seleccionar un contratista');
      errors++;
    }

    if (
      this.model.idEstado == EstadoSolicitud.SOLICITADO &&
      this.model.lista_documentos_personal.length == 0
    ) {
      this.alertDialogService.open(
        'Debe registrar por lo menos un documento requerido en la seccion PERSONAL.'
      );
    }
    return errors == 0;
  }

  openDialogTipoDocumento(idSeccion: SolicitudSeccion): void {
    let tipoDocumento = new AdjuntarTipoDocumentoModel();
    tipoDocumento.idSeccion = idSeccion;
    
    if(this.model.idTipoVisitaSelected)
      tipoDocumento.idTipoVisita = this.model.idTipoVisitaSelected;
    
    switch (idSeccion) {
      case SolicitudSeccion.Personal: {
        tipoDocumento.listaTipoDocumentos = this.model.lista_documentos_personal;
        // this.listaSearchDocumentacionPersonalRequerido.forEach((q) => {
        //   if (q.idDocumento == OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL) {
        //     tipoDocumento.listaTipoDocumentos.push(q);
        //   } else {
        //     let index = this.model.lista_documentos_personal.findIndex(
        //       (r) => r.idDocumento == q.idDocumento
        //     );

        //     if (index == -1) {
        //       tipoDocumento.listaTipoDocumentos.push(q);
        //     }
        //   }
        // });
        break;
      }
      case SolicitudSeccion.Equipos: {
        tipoDocumento.listaTipoDocumentos = this.model.lista_documentos_equipos;
        // this.listaSearchDocumentacionEquiposRequeridos.forEach((q) => {
        //   if (q.idDocumento == OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO) {
        //     tipoDocumento.listaTipoDocumentos.push(q);
        //   } else {
        //     let index = this.model.lista_documentos_equipos.findIndex(
        //       (r) => r.idDocumento == q.idDocumento
        //     );

        //     if (index == -1) {
        //       tipoDocumento.listaTipoDocumentos.push(q);
        //     }
        //   }
        // });
        break;
      }
      case SolicitudSeccion.Vehiculos: {
        tipoDocumento.listaTipoDocumentos = this.model.lista_documentos_vehiculos;
        // this.listaSearchDocumentacionVehiculosRequeridos.forEach((q) => {
        //   if (q.idDocumento == OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO) {
        //     tipoDocumento.listaTipoDocumentos.push(q);
        //   } else {
        //     let index = this.model.lista_documentos_vehiculos.findIndex(
        //       (r) => r.idDocumento == q.idDocumento
        //     );

        //     if (index == -1) {
        //       tipoDocumento.listaTipoDocumentos.push(q);
        //     }
        //   }
        // });
        break;
      }
      case SolicitudSeccion.DocumentacionTecnica: {
        tipoDocumento.listaTipoDocumentos = this.model.documentosTecnicos.map((item) => {
          let documento = new DocumentacionRequeridaModel();
            documento.idConfiguracionDocumento = item.idConfiguracionDocumento;
            // item.idMaestroDocumento;            
            documento.documento = item.documento;
            documento.esPredeterminado = item.esPredeterminado;
            documento.idRequisito = item.idRequisito;
            // documento2.seccion = idSeccion;
            documento.controlarFechas = item.controlarFechas;
            documento.esRequisitoBloqueado =
              documento.idRequisito === DocumentoTipoRequisito.TODOS;

            return documento;
        });
        // this.listaSearchDocumentacionTecnicaRequerida.forEach((q) => {
        //   if (q.idDocumento == OtroDocumentoSecciones.OTRO_DOCUMENTO_TECNICO) {
        //     tipoDocumento.listaTipoDocumentos.push(q);
        //   } else {
        //     let index = this.model.documentosTecnicos.findIndex(
        //       (r) => r.idDocumento == q.idDocumento
        //     );

        //     if (index == -1) {
        //       tipoDocumento.listaTipoDocumentos.push(q);
        //     }
        //   }
        // });
        break;
      }
    }

    const dialogRef = this.dialog.open(AdjuntarTipoDocumentoDialogComponent, {
      width: '500px',
      data: tipoDocumento,
    });

    dialogRef.afterClosed().subscribe((result) => {
      // this.animal = result;
      // console.log(result);
      if (result) {
        let documento: DocumentacionRequeridaModel =
          new DocumentacionRequeridaModel();

        documento.idConfiguracionDocumento = result.idConfiguracionDocumento;
        documento.idMaestroDocumento = result.idMaestroDocumento;
        documento.documento = result.documento;
        documento.esPredeterminado = false;
        documento.idRequisito = result.idRequisito;
        documento.seccion = idSeccion;

        documento.controlarFechas = result.controlarFechas;
        documento.esRequisitoBloqueado =
          result.idRequisito === DocumentoTipoRequisito.TODOS;

        switch (idSeccion) {
          case SolicitudSeccion.Personal: {
            this.model.lista_documentos_personal.push(documento);

            // if (
            //   result.idTipoDocumento !==
            //   OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL
            // ) {
            //   this.listaSearchDocumentacionPersonalRequerido = this.listaSearchDocumentacionPersonalRequerido.filter(
            //     (p) => p.idDocumento !== result.idTipoDocumento
            //   );
            // }

            this.tablePersonal.renderRows();
            break;
          }
          case SolicitudSeccion.Equipos: {
            this.model.lista_documentos_equipos.push(documento);

            // if (
            //   result.idTipoDocumento ===
            //   OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO
            // ) {
            //   this.listaSearchDocumentacionEquiposRequeridos = this.listaSearchDocumentacionEquiposRequeridos.filter(
            //     (p) => p.idDocumento !== result.idTipoDocumento
            //   );
            // }

            this.tableEquipos.renderRows();
            break;
          }
          case SolicitudSeccion.Vehiculos: {
            this.model.lista_documentos_vehiculos.push(documento);

            // if (
            //   result.idTipoDocumento ===
            //   OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO
            // ) {
            //   this.listaSearchDocumentacionVehiculosRequeridos = this.listaSearchDocumentacionVehiculosRequeridos.filter(
            //     (p) => p.idDocumento !== result.idTipoDocumento
            //   );
            // }

            this.tableVehiculos.renderRows();
            break;
          }
          case SolicitudSeccion.DocumentacionTecnica: {
            // this.model.lista_documentos_tecnicos.push(documento);
            let documento2: SolicitudDocumentoTecnicoModel =
              new SolicitudDocumentoTecnicoModel();

            documento2.idConfiguracionDocumento = result.idConfiguracionDocumento;
            documento2.idMaestroDocumento = result.idMaestroDocumento;
            documento2.documento = result.documento;
            documento2.esPredeterminado = false;
            documento2.idRequisito = result.idRequisito;
            // documento2.seccion = idSeccion;

            documento2.controlarFechas = result.controlarFechas;
            documento2.esRequisitoBloqueado =
              result.idRequisito === DocumentoTipoRequisito.TODOS;
              
            this.model.documentosTecnicos.push(documento2);
            

            // if (
            //   result.idTipoDocumento ===
            //   OtroDocumentoSecciones.OTRO_DOCUMENTO_TECNICO
            // ) {
            //   this.listaSearchDocumentacionTecnicaRequerida = this.listaSearchDocumentacionTecnicaRequerida.filter(
            //     (p) => p.idDocumento !== result.idTipoDocumento
            //   );
            // }

            this.tableDocumentacionTecnica.renderRows();
            break;
          }
        }
      }
    });
  }

  deletePersona(element: DocumentacionRequeridaModel): void {
    // if (element.idDocumento !== OtroDocumentoSecciones.OTRO_DOCUMENTO_PERSONAL)
    //   this.listaSearchDocumentacionPersonalRequerido.push(element);

    this.model.lista_documentos_personal =
      this.model.lista_documentos_personal.filter((item) => item !== element);
  }

  deleteEquipo(element: DocumentacionRequeridaModel): void {
    // if (element.idDocumento !== OtroDocumentoSecciones.OTRO_DOCUMENTO_EQUIPO)
    //   this.listaSearchDocumentacionEquiposRequeridos.push(element);

    this.model.lista_documentos_equipos =
      this.model.lista_documentos_equipos.filter((item) => item !== element);
  }

  deleteVehiculo(element: DocumentacionRequeridaModel): void {
    // if (element.idDocumento !== OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO)
    //   this.listaSearchDocumentacionVehiculosRequeridos.push(element);

    this.model.lista_documentos_vehiculos =
      this.model.lista_documentos_vehiculos.filter((item) => item !== element);
  }

  deleteDocumentoTecnico(element: ISolicitudDocumentoTecnicoModel): void {
    // if (element.idDocumento !== OtroDocumentoSecciones.OTRO_DOCUMENTO_VEHICULO)
    //   this.listaSearchDocumentacionVehiculosRequeridos.push(element);

    // this.model.lista_documentos_tecnicos =
    //   this.model.lista_documentos_tecnicos.filter((item) => item !== element);

    this.model.documentosTecnicos =
      this.model.documentosTecnicos.filter((item) => item !== element);
  }

  submitForm(){
    // this.model.idEstado = EstadoSolicitud.SOLICITADO;
    this.model.documentosRequeridos = [];

    this.model.lista_documentos_personal.forEach((p) => {
    this.model.documentosRequeridos.push(p);
    });
    this.model.lista_documentos_equipos.forEach((p) => {
    this.model.documentosRequeridos.push(p);
    });
    this.model.lista_documentos_vehiculos.forEach((p) => {
    this.model.documentosRequeridos.push(p);
    });
    // this.model.lista_documentos_tecnicos.forEach((p) => {
    //   this.model.documentosRequeridos.push(p);
    // });

    if (
      (
        this.model.idEstado == EstadoSolicitud.SOLICITADO &&
        this.model.lista_documentos_personal.length > 0) ||
      this.model.idEstado == EstadoSolicitud.EN_ELABORACION
    ) {
      this.solicitudService.update(this.model).subscribe((p) => {
        if (this.model.idEstado == EstadoSolicitud.SOLICITADO) {
          this.alertDialogService.open('La solicitud fue enviada.'); //options
          this.router.navigate(['/solicitudes-engie']);
        } else if (this.model.idEstado == EstadoSolicitud.EN_ELABORACION) {
          this.alertDialogService.open('La solicitud fue registrada.'); //options          
        }
      });
    }
  }
}
